<template>
    <div :class='keyboardClass'></div>
</template>
  
<script>
    import Keyboard from 'simple-keyboard'
    import 'simple-keyboard/build/css/index.css'

    export default {
        name: 'SimpleKeyboard',
        props: {
            keyboardClass: {
                default: 'simple-keyboard',
                type: String
            },
            input: {
                type: String
            }
        },
        data: () => ({
            keyboard: null
        }),
        mounted() {
            this.keyboard = new Keyboard(this.keyboardClass, {
                onChange: this.onChange,
                onKeyPress: this.onKeyPress,
                layout: {
                    'default': [
                        'q w e r t y u i o p',
                        'a s d f g h j k l',
                        '{uppercase} z x c v b n m {bksp}',
                        '{numbers} {space} {enter} {done}'
                    ],
                    'uppercase': [
                        'Q W E R T Y U I O P',
                        'A S D F G H J K L',
                        '{default} Z X C V B N M {bksp}',
                        '{numbers} {space} {enter} {done}'
                    ],
                    'numbers': [
                        '1 2 3 4 5 6 7 8 9 0',
                        '- / : ; ( ) € @ "',
                        "{symbols} . , ? ! ' {bksp}",
                        '{default} {space} {done}'
                    ],
                    'symbols': [
                        '[ ] { } # % ^ * + =',
                        '_ \ / | ~ < > $ ∑ ¥ •',
                        "{numbers} . , ? ! ' {bksp}",
                        '{default} {space} {done}'
                    ],
                },
                display: {
                    '{space}': ' ',
                    '{bksp}': '<',
                    '{enter}': '↵',
                    '{uppercase}': '⬆',
                    '{default}': 'abc',
                    '{numbers}': '123',
                    '{symbols}': '#+=',
                    '{done}': 'Ok'
                }
            })
        },
        methods: {
            onChange(input) {
                this.$emit('onChange', input)
            },
            onKeyPress(button) {
                if (button === '{default}') {
                    return this.keyboard.setOptions({
                        layoutName: 'default'
                    })
                }
                if (button === '{uppercase}') {
                    return this.keyboard.setOptions({
                        layoutName: 'uppercase'
                    })
                }
                if (button === '{numbers}') {
                    return this.keyboard.setOptions({
                        layoutName: 'numbers'
                    })
                }
                if (button === '{symbols}') {
                    return this.keyboard.setOptions({
                        layoutName: 'symbols'
                    })
                }
                this.$emit('onKeyPress', button)
            },
        },
        watch: {
            input(input) {
                this.keyboard.setInput(input)
            }
        }
    }
</script>

<style>
    .hg-theme-default .hg-button-bksp {
        background-color: #bcbcbc;
    }

    .hg-theme-default .hg-button-space {
        width: 20vh;
    }
</style>